import { createContext } from 'react';
import type { CreateInput, ID, Service, ServiceCategory, UpdateInput } from '@/types';

export interface ServiceContextValue {
  categories: ServiceCategory[];
  services: Service[];
  isLoading: boolean;
  createCategory: (input: Omit<CreateInput<ServiceCategory>, 'businessId'>) => Promise<ServiceCategory>;
  updateCategory: (id: ID, patch: UpdateInput<ServiceCategory>) => Promise<void>;
  deleteCategory: (id: ID) => Promise<void>;
  createService: (input: Omit<CreateInput<Service>, 'businessId'>) => Promise<Service>;
  updateService: (id: ID, patch: UpdateInput<Service>) => Promise<void>;
  duplicateService: (id: ID) => Promise<void>;
  deleteService: (id: ID) => Promise<void>;
  toggleFavourite: (id: ID) => Promise<void>;
  setStatus: (id: ID, status: Service['status']) => Promise<void>;
}

export const ServiceContext = createContext<ServiceContextValue | null>(null);
